export const itemsPensee = [
  {
    name: 'Pourquoi je fais ce blog ?',
    date: '29/09/2024',
    onClick: () =>
      window.open('https://admiring-wing-b7d9a1.netlify.app/', '_blank'),
    consultingBy: ['tristan.lemire.sio@gmail.com'],
  },
];
